module.exports = __webpack_public_path__ + "img/img18.77a96059.svg";